export const requestMotionPermission = async () => {
  console.log("requesting motion permission");
  if (
    // @ts-ignore
    DeviceOrientationEvent.requestPermission &&
    // @ts-ignore
    DeviceMotionEvent.requestPermission
  ) {
    try {
      // @ts-ignore
      const permissionState = await DeviceOrientationEvent.requestPermission();
      // @ts-ignore
      const motionPermissionState = await DeviceMotionEvent.requestPermission();
      console.log("permissionState", permissionState, motionPermissionState);
      return permissionState;
    } catch (error: any) {
      switch (error.name) {
        case "NotAllowedError":
          return "denied" as const;
        default:
          return "denied" as const;
      }
    }
  } else {
    return "granted";
  }
};
